module.exports = __webpack_public_path__ + "images/icons_v2/chevron-down-e83e161f.svg";